<template>
  <b-tabs
    content-class="col-12 px-sm-1 px-0  mb-sm-0 mb-5"
    pills
    nav-wrapper-class=" col-12"
    nav-class="justify-content-center"
    v-model="tabs"
  >
    <b-tab v-if="course.description">
      <template #title>
        <feather-icon icon="BookOpenIcon" size="18" class="mr-1" />
        <span class="font-weight-bold">توضیحات</span>
      </template>
      <b-card>
        <div class="text-justify p-sm-1" v-html="course.description"></div>
      </b-card>
    </b-tab>
    <!-- <b-tab
      v-if="
        course.events && course.events.events && course.events.events.length
      "
    >
      <template #title>
        <feather-icon icon="RefreshCcwIcon" size="18" class="mr-1" />
        <span class="font-weight-bold">رویداد ها</span>
      </template>
      <events-tab :events="course.events.events" :isMount="isMount" />
    </b-tab> -->
    <b-tab v-if="course.faqs && course.faqs.faqs && course.faqs.faqs.length">
      <template #title>
        <feather-icon icon="FileTextIcon" size="18" class="mr-1" />
        <span class="font-weight-bold">پرسش و پاسخ</span>
      </template>
      <faqs-tab :faqs="course.faqs.faqs" />
    </b-tab>
    <b-tab>
      <template #title>
        <feather-icon icon="TwitchIcon" size="18" class="mr-1" />
        <span class="font-weight-bold">سوالات کاربران</span>
      </template>
      <comments regardingType="course" />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab, BCard } from "bootstrap-vue";
// import EventsTab from "./EventsTab.vue";
import FaqsTab from "./FaqsTab.vue";
import Comments from "@core/components/comments/Comments.vue";

export default {
  components: {
    BTabs,
    BTab,
    // EventsTab,
    FaqsTab,
    Comments,
    BCard,
  },
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    tabs(newVal) {
      if (newVal == 1) {
        setTimeout(() => {
          this.isMount = true;
        }, 1000);
      } else {
        this.isMount = false;
      }
    },
  },
  mounted() {
    if (this.tabs == 0) {
      this.isMount = true;
    } else {
      this.isMount = false;
    }
  },
  data() {
    return {
      tabs: 0,
      isMount: false,
    };
  },
};
</script>
